import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'titleActivation': {
    id: 'license.activationPanel.title.activation',
    description: 'License activation panel title for activation',
    defaultMessage: 'Activate license',
  },
  'titleUpgrade': {
    id: 'license.activationPanel.title.upgrade',
    description: 'License activation panel title for upgrade',
    defaultMessage: 'Upgrade license',
  },
  'emptyLicenseTypeLabel': {
    id: 'license.activationPanel.emptyLicenseTypeLabel',
    description: 'Label for empty-option in license type selector.',
    defaultMessage: 'Choose license type',
  },
  'emptySellerLabel': {
    id: 'license.activationPanel.emptySellerLabel',
    description: 'Label for empty-option in seller selector.',
    defaultMessage: 'Choose seller',
  },
  'licenseLengthHelpText': {
    id: 'license.activationPanel.helptext.length',
    description: 'License length info',
    defaultMessage: 'Period is {periodInMonths}+{extraMonths} months',
  },
  'licensePriceActivationHelpText': {
    id: 'license.activationPanel.activation.helptext.price',
    description: 'License price info for activation',
    defaultMessage: 'Price is between {minPrice} and {maxPrice} euros',
  },
  'licensePriceUpgradeHelpText': {
    id: 'license.activationPanel.upgrade.helptext.price',
    description: 'License price info for upgrade',
    defaultMessage: 'License price is {rrp} euros and compensation {compensation} euros',
  },
  'activationAction': {
    id: 'license.activationPanel.button.activate.label',
    description: 'New license activation button label',
    defaultMessage: 'Activate',
  },
  'upgradeAction': {
    id: 'license.activationPanel.button.upgrade.label',
    description: 'Current license upgrade button label',
    defaultMessage: 'Upgrade',
  },
  'cancellationAction': {
    id: 'license.activationPanel.button.cancel.label',
    description: 'New license activation cancellation button label',
    defaultMessage: 'Cancel',
  },
  'submitFormAction': {
    id: 'license.activationPanel.licenseForm.button.submit.label',
    description: 'License activation panel license form submit button label',
    defaultMessage: 'Continue',
  },
  'backAction': {
    id: 'license.activationPanel.button.back.label',
    description: 'License activation panel back button label',
    defaultMessage: 'Back',
  },
  'confirmationTitleActivation': {
    id: 'license.activationPanel.dialog.confirmation.activation.title',
    description: 'Title for new license activation confirm dialog',
    defaultMessage: 'Activate new license?',
  },
  'confirmationTitleUpgrade': {
    id: 'license.activationPanel.dialog.confirmation.upgrade.title',
    description: 'Title for license upgrade confirm dialog',
    defaultMessage: 'Upgrade current license?',
  },
  'confirmationActionYes': {
    id: 'license.activationPanel.dialog.confirmation.button.yes.label',
    description: 'Label for new license activation confirmation yes-button',
    defaultMessage: 'Yes',
  },
  'confirmationActionNo': {
    id: 'license.activationPanel.dialog.confirmation.button.no.label',
    description: 'Label for new license activation confirmation no-button',
    defaultMessage: 'No',
  },
  'licenseContinuousHelpText': {
    id: 'license.activationPanel.helptext.continuous',
    description: 'License continuous helptext',
    defaultMessage: 'Should the license be automatically renewed et the end of period?',
  },
  'upgradeWarning': {
    id: 'license.controlPanel.upgradeWarning',
    description: 'Warning that upgrading company\'s license replaces the currently active one.',
    defaultMessage: 'Note that activating a new license replaces the currently active one.',
  }
});
